import lazyLoading from './lazyLoading';

export default {
  name: 'Dashboard',
  path: '/dashboard',
  component: lazyLoading('dashboard/DashboardCustom'),
  meta: {
    default: true,
    title: 'menu.dashboard',
    iconClass: 'vuestic-icon vuestic-icon-dashboard',
    auth: true,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/dashboard.js